import * as Spring from "react-spring";

export function card() {
	return Spring.useSpring({
		from: { opacity: 0 },
		to: { opacity: 1 },
		delay: 400
	});
}
